import { render } from "./Presence.vue?vue&type=template&id=5dece7ca&scoped=true"
import script from "./Presence.vue?vue&type=script&lang=js"
export * from "./Presence.vue?vue&type=script&lang=js"

import "./Presence.vue?vue&type=style&index=0&id=5dece7ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dece7ca"]])

export default __exports__